import { render, staticRenderFns } from "./PainelChat.vue?vue&type=template&id=676e2c60&scoped=true"
import script from "./PainelChat.vue?vue&type=script&lang=js"
export * from "./PainelChat.vue?vue&type=script&lang=js"
import style0 from "./PainelChat.vue?vue&type=style&index=0&id=676e2c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e2c60",
  null
  
)

export default component.exports